/**
 * Core / Mint / Methods: Mounted
 * ------------------------------------------------------------------------------
 * - Export of shared functions to run on mounted() of a section file
 * - Typically run within `mint-sections.js`
 * - This file exists because `CollectionPageContainer` runs outside of
 *   Mint Sections/Components, so it needs to synchronise with everything.
 * - Long term plan is to refactor `CollectionPageContainer` to follow conventions
 *   of other /vue/section/* files.
 */
import { storageNamespace } from '~/helpers/storage-namespaces'

/**
 * Export methods to run on section mount.
 * @param {Object} instance - Vue instance.
 */
export default (instance) => {
  instance.setEventBusListeners()

  /**
   * For API based shared-stores, retrieve a cached version
   * and set the data.
   * - Mint Core will have performed API call on page load and cached in browser.
   * - As other sections mount, get the data and set in section stores.
   * - Any subsequent API update will be handled and updated via EventBus.
   */
  const cachedCart = JSON.parse(
    sessionStorage.getItem(storageNamespace.pinia.cart),
  )

  const cachedLocale = JSON.parse(
    sessionStorage.getItem(storageNamespace.pinia.locale),
  )

  const cachedWishlist = JSON.parse(
    sessionStorage.getItem(storageNamespace.pinia.wishlist),
  )

  if (cachedCart) {
    instance.setCart(cachedCart)
  }

  if (cachedLocale) {
    instance.setLocale(cachedLocale, true)
  }

  if (cachedWishlist) {
    instance.setWishlist(cachedWishlist)
  }

  /**
   * Only utilise cache if on a PDP.
   */
  if (mint.request.pageType === 'product') {
    const cachedProduct = JSON.parse(
      sessionStorage.getItem(storageNamespace.pinia.product),
    )

    if (cachedProduct) {
      instance.setProduct({
        completeTheLook: cachedProduct.completeTheLook,
        isSection: true,
        product: cachedProduct.productData,
        variant: cachedProduct.currentVariant,
      })
    }
  } else {
    sessionStorage.removeItem(storageNamespace.pinia.product)
  }

  /**
   * Execute Pinia functions on mount.
   * - Any method call here should also be added:
   * - mint-components.js
   * - mint-core.js
   * - mint-section.js
   * - Ensures that Pinia state is shared between all
   *   Vue instances.
   */
  instance.setFeatureFlags()
  instance.handleResize()
}